<template>
    <div class="xiaofeijilu">
        <!-- 统计卡片 -->
        <div class="stats-card">
            <div class="card-header">
                <div class="header-title">消费记录</div>
            </div>
            <div class="card-body">
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.money }}</div>
                    <div class="stat-label">总共充值（元）</div>
                </div>
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.virtualCoin }}</div>
                    <div class="stat-label">获得缩币（个）</div>
                </div>
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.consumptionCoin }}</div>
                    <div class="stat-label">消费缩币（个）</div>
                </div>
                <div class="stat-item highlight">
                    <div class="stat-value">{{ statistics.residueCoin }}</div>
                    <div class="stat-label">缩币余额（个）</div>
                </div>
            </div>
        </div>

        <!-- 搜索表单卡片 -->
        <div class="search-card">
            <div class="card-header">
                <div class="header-title">筛选查询</div>
            </div>
            <div class="card-body">
                <el-form inline class="search-form">
                    <el-form-item label="数据作者">
                        <el-input v-model="form.nickName" placeholder="请输入" style="width: 120px" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="彩种">
                        <el-select v-model="form.preType" placeholder="请选择彩种" clearable style="width: 140px">
                            <el-option v-for="(item, index) in lottery" :key="index" :value="item.dictLabel"
                                :label="item.dictLabel"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="日期范围">
                        <el-date-picker v-model="pickerTime" @change="pickerChange" type="daterange"
                            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList">搜索</el-button>
                        <el-button @click="getList">刷新</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 消费记录表格 -->
        <div class="table-card">
            <div class="card-header">
                <div class="header-title">消费明细</div>
            </div>
            <el-table :data="tableData" border style="width: 100%"
                :header-cell-style="{ color: '#ffffff', backgroundColor: '#409eff', fontWeight: '600' }">
                <el-table-column prop="createTime" label="购买时间" min-width="100" show-overflow-tooltip />
                <el-table-column prop="productModel" label="购买数据种类">
                    <template slot-scope="scope">
                        <span :style="{ color: getProductModelColor(scope.row.productModel), fontWeight: '500' }">
                            {{ getProductModelName(scope.row.productModel) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="productAuthor" label="购买数据作者" show-overflow-tooltip />
                <el-table-column prop="preType" label="购买彩种" />
                <el-table-column prop="number" label="购买期数" />
                <el-table-column prop="consumptionCoin" label="消费缩币">
                    <template slot-scope="scope">
                        <span style="color: #ef4444; font-weight: 500;">{{ scope.row.consumptionCoin }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="residueCoin" label="缩币余额">
                    <template slot-scope="scope">
                        <span style="color: #10b981; font-weight: 500;">{{ scope.row.residueCoin }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination style="padding: 20px; text-align: right;" background layout="prev, pager, next"
                @current-change="changePage" :page-size="listPagin.limit" :total="listPagin.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import hxlPagin from '@/components/hxl-pagin';
import { count, consumptionRecord } from '@/api/chongzhi';
import { queryLotteryType } from '@/api/common';
export default {
    components: { hxlPagin },
    data() {
        return {
            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },
            lottery: [],
            pickerTime: '',
            form: {
                pageNum: 1,
                pageSize: 10,
                nickName: null,
                preType: null,
                params: {
                    beginTime: null,
                    bendTime: null,
                },
            },
            tableData: [],
            statistics: {}
        }
    },
    watch: {
        pickerTime(val) {
            this.form.params = !val ? {} : ''
        },
        'form.productType'(val) {
            console.log('!val', val);
            this.form.productType = val == '' ? null : val
        }
    },
    filters: {
        findLottery(value, lottery) {
            const obj = lottery.find(item => item.dictValue === value);
            return obj ? obj.dictLabel : null;
        }
    },
    mounted() {
        // 消费统计
        count().then(res => this.statistics = res.data)

        queryLotteryType().then(res => {
            this.lottery = res.data.map(item => JSON.parse(JSON.stringify(item, ['dictLabel', 'dictValue'])))
            this.getList()
        })
    },
    methods: {
        getProductModelName(model) {
            const modelMap = {
                '0': '缩水师',
                '1': '技巧师'
            }
            return modelMap[model] || ''
        },

        getProductModelColor(model) {
            const colorMap = {
                '0': '#409eff',  // 缩水师 - 蓝色
                '1': '#f59e0b'   // 技巧师 - 橙色
            }
            return colorMap[model] || '#333'
        },

        // 分页状态变化
        changePage(e) {
            this.form.pageNum = e
            this.listPagin.page = e
            this.getList();
        },

        getList() {
            // 消费记录
            consumptionRecord(this.form).then(res => {
                let { rows, total } = res.data
                this.tableData = rows
                this.listPagin.total = total
            })
        },
        pickerChange(e) {
            this.form.params = {
                beginTime: e[0],
                bendTime: e[1],
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.xiaofeijilu {

    // 统计卡片
    .stats-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        margin-bottom: 20px;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 0.5px;
            }
        }

        .card-body {
            padding: 24px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;

            .stat-item {
                flex: 1;
                min-width: 140px;
                text-align: center;
                padding: 16px;
                background: #f8fafc;
                border-radius: 12px;
                transition: all 0.3s ease;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                }

                &.highlight {
                    background: linear-gradient(135deg, #fff5f5 0%, #ffeaea 100%);
                    border: 1px solid #ffd6d6;

                    .stat-value {
                        color: #E92728;
                    }
                }

                .stat-value {
                    font-size: 24px;
                    font-weight: 700;
                    color: #334155;
                    margin-bottom: 6px;
                }

                .stat-label {
                    font-size: 13px;
                    color: #64748b;
                }
            }
        }
    }

    // 搜索表单卡片
    .search-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        margin-bottom: 20px;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 0.5px;
            }
        }

        .card-body {
            padding: 20px 24px;

            .search-form {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;

                :deep(.el-form-item) {
                    margin-bottom: 0;
                    margin-right: 16px;
                }

                :deep(.el-form-item__label) {
                    color: #4a5568;
                    font-weight: 500;
                }
            }
        }
    }

    // 表格卡片
    .table-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        overflow: visible;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 0.5px;
            }
        }

        :deep(.el-table) {
            --el-table-row-hover-bg-color: #f8fafc;
        }

        :deep(.el-table__row) {
            transition: background-color 0.2s ease;
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .xiaofeijilu {

        /* 统计卡片 */
        .stats-card {

            .card-header {
                padding: 12px 14px;

                .header-title {
                    font-size: 15px;
                }
            }

            .card-body {
                padding: 14px;
                gap: 10px;

                .stat-item {
                    min-width: 0;
                    flex: 1 1 46%;
                    padding: 12px 8px;

                    .stat-value {
                        font-size: 20px;
                    }
                }
            }
        }

        /* 筛选查询：标签在上、控件整行，避免日期区间(350px)撑破屏幕 */
        .search-card {

            .card-header {
                padding: 12px 14px;

                .header-title {
                    font-size: 15px;
                }
            }

            .card-body {
                padding: 14px;

                .search-form {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 12px;

                    :deep(.el-form-item) {
                        display: block;
                        margin-right: 0;
                        margin-bottom: 0;
                    }

                    :deep(.el-form-item__label) {
                        float: none;
                        display: block;
                        width: auto !important;
                        padding: 0 0 6px;
                        line-height: 1.6;
                        text-align: left;
                    }

                    :deep(.el-form-item__content) {
                        margin-left: 0 !important;
                        line-height: 1.6;
                    }

                    /* 输入框、下拉、日期区间统一占满整行 */
                    :deep(.el-input),
                    :deep(.el-select),
                    :deep(.el-date-editor) {
                        width: 100% !important;
                        max-width: 100%;
                    }

                    /* 搜索 / 刷新按钮 */
                    :deep(.el-form-item:last-child) {
                        display: flex;
                        gap: 8px;
                    }
                }
            }
        }
    }
}
</style>